module.exports = __webpack_public_path__ + "static/img/product_society_society_sfdmx.bcee685.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/product_society_society_sfdmx.png
// module id = lGK/
// module chunks = 0